var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHalfStar = function SvgHalfStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.078.006c.18.028.337.15.414.328l1.995 4.586c.056.127.17.215.301.231l4.733.592c.21.027.387.18.452.394a.6.6 0 0 1-.147.598l-3.5 3.427a.42.42 0 0 0-.116.376l.93 4.951a.59.59 0 0 1-.212.577.52.52 0 0 1-.584.037l-4.158-2.468A.37.37 0 0 0 8 13.583V0z",
    opacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.922.006a.55.55 0 0 0-.414.328L5.513 4.92a.38.38 0 0 1-.301.231l-4.733.592a.55.55 0 0 0-.453.394.6.6 0 0 0 .148.598l3.5 3.427a.42.42 0 0 1 .116.376l-.93 4.951a.59.59 0 0 0 .212.577c.171.132.4.146.584.037l4.158-2.468A.37.37 0 0 1 8 13.583V0z"
  })));
};
export default SvgHalfStar;